webpackJsonp([35783957827783],{

/***/ 120:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "div",
	    { className: "content_sections" },
	    Glamor.createElement(
	      "h1",
	      null,
	      "Home"
	    ),
	    Glamor.createElement(
	      "div",
	      { className: "home-about-description" },
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "Boris is a consultant, technical advisor and angel investor in Silicon Valley. He works both with large fortune 500 enterprise software customers and also helping founders and engineering teams at startups become successful."
	      ),
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "As a Serial Entrepreneur, Boris has helped lead multiple startups from initial concept to market success. He has spent over 20 years in Sillicon Valley, both in leading development teams to build scalable enterprise software, and inthe field of innovating solutions for fortune 500 customers. He now leverages all of his experience in Silicon Valley to advise and fund early stage startups."
	      ),
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "Most recently, Boris worked as an advanced solution group at Akamai, working with large strategic customers on best practices in web development. Previously, Boris led the Center of Excellence at AppDynamics, where he worked with thelargest customers to architect solutions for Application Performance Management (APM). He spent his initial years at AppDynamics building out the data and caching layers for the initial product, working on scaling and performance to support some of the largest applications in the cloud."
	      ),
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "Boris began his career over 20 years ago in Silicon Valley where he studied at U.C. Berkeley and did database research with the database pioneer Professor Stonebraker on the postgres project. He was a key part of 2 database startups where he worked on pinoreering database kernel technology. He then went on to Infravio where he developed products for the then emerging Web Services space. Later, at Oracle, Boris spent years in senior technical roles in the areas of Systems Management, Data Warehousing, ETL, data modeling and data management."
	      ),
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "Through work at both successful startups and large enterprise software companies, Boris has always been active engaging with customers. His customer work encompasses a wealth of knowledge in large cloud, big data and distributed environments."
	      ),
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "His areas of expertise include: Front End Optimization, Website Performance, Application Performance Management (APM), Server Side development, server performance and scalability, SaaS, Cloud Architecture, Database kernels, OLAP, ETL, Analytics, and CRM systems"
	      ),
	      " ",
	      Glamor.createElement(
	        "span",
	        { className: "about_para" },
	        "In his spare time Boris likes to play with his two young boys, travel to exotic countries, and root for his favorite football team. Go, Raiders!"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-50387cc0a032befcfaa3.js